import FeatureFlags from './FeatureFlags'

export const eligibleForAccountsImport = ({item, userConfig}) => (
  FeatureFlags.isEnabled('plaid') &&
  userConfig.get('premium') &&
  !!item.get('importable')
)
